import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddLocationComp from "./Component/AddLocationComp"


const AddLocation =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddLocationComp />
        </div>
        <Footer />
        </>
    )
}

export default AddLocation